import { ChangeDetectionStrategy, Component, computed, inject, input, output, ViewEncapsulation } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ApiTypes, getErrorMessage, TrackingFeature } from '@hyundai/ng-common-lib';
import { InputSelectComponent, InputTextareaComponent, M020C080InputDatepickerComponent } from '@hyundai/ui';
import { Store } from '@ngrx/store';
import DistributionContactTemplateComponent from '../distribution-contact-template/distribution-contact-template.component';
import { DistributionForm } from '../distribution-overview-step/distribution-overview-step.component';

@Component({
    selector: 'lib-distribution-testdrive-step',
    standalone: true,
    templateUrl: './distribution-testdrive-step.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        InputSelectComponent,
        InputTextareaComponent,
        DistributionContactTemplateComponent,
        M020C080InputDatepickerComponent,
        ReactiveFormsModule,
    ],
})
export default class DistributionTestDriveStepComponent {
    getErrorMessage = getErrorMessage;

    store = inject(Store);
    vehicle = input.required<ApiTypes.VehicleDetail>();
    form = input.required<FormGroup<DistributionForm>>();
    errorMsg = input<string>();
    submitClicked = output();

    trackingStarted = false;

    minDate = computed(() => {
        const result = new Date();
        result.setDate(result.getDate() + 2);
        if (result.getDay() === 0) {
            result.setDate(result.getDate() + 1);
        }
        return result;
    });

    maxDate = computed(() => {
        const date = new Date();

        return new Date(date.setMonth(date.getMonth() + 6));
    });

    holidays = computed(() => {
        return this.vehicle().dealer.holidays.map((holiday) => new Date(holiday));
    });

    trackingStart(): void {
        if (this.form().controls.tab.value !== 'probefahrt' || this.trackingStarted) {
            return;
        }
        this.trackingStarted = true;
        this.store.dispatch(TrackingFeature.actions.formTestDriveStartTracking({ vehicle: this.vehicle() }));
    }
}
